// extracted by css-extract-rspack-plugin
export default {"AgoTimestampLink":"Ago-module__AgoTimestampLink__C5C_IJJ","timestampText":"Ago-module__timestampText__xM3Y6bZ"};